import {
  Car,
  CarImage,
  CarMileageEntry,
  Visit,
  VisitContact,
  VisitTimeProposition,
  Workshop,
  WorkshopImage,
  WorkshopRejectedVisit,
} from '../../models';
import { GET_CLIENT_VISIT_DETAIL, GET_WORKSHOP_VISIT_DETAIL } from '../constants/visit';

/* eslint-disable camelcase */
const convertCar = (car, car_ownership, finished, image) => {
  const mileage = car_ownership?.mileage
    ? new CarMileageEntry(car_ownership?.mileage?.id, car_ownership?.mileage?.mileage_in_kilometers)
    : null;
  return new Car(
    car.id,
    car.make_name,
    car.model_name,
    car.variant,
    car.version,
    car.vin,
    car.production_year,
    car.fuel,
    car.engine_capacity,
    car.engine_power_kw,
    car.curb_weight,
    car.first_registration_date,
    car_ownership.car_nickname,
    car_ownership.color,
    car_ownership.owner_id,
    car_ownership.registration_number,
    car_ownership.id,
    finished,
    image,
    mileage,
  );
};

const convertWorkshop = (workshop, image) => {
  return new Workshop(
    workshop.id,
    workshop.name,
    workshop.slug,
    workshop.country,
    workshop.city,
    workshop.street,
    workshop.street_number,
    workshop.postcode,
    workshop.latitude,
    workshop.longitude,
    workshop.website,
    workshop.description,
    workshop?.number_of_reviews,
    workshop?.average_rate,
    true,
    false,
    image,
  );
};

export const getClientVisitDetail = (data) => {
  const {
    id,
    car_ownership,
    workshop_ownership,
    scheduled_time,
    message_from_client,
    message_from_workshop,
    status,
    time_preference,
    time_proposition,
    alternative_time_proposition,
    car,
    car_images,
    workshop,
    rejection,
    issuing_invoice,
    service_scope_status,
    is_reviewed,
    initiated_by,
  } = data;

  const image = car_images?.length > 0 ? new CarImage(car_images[0].id, car_images[0].image) : null;
  const convertedCar = convertCar(car, car_ownership, undefined, image);

  const { workshop_images } = workshop;
  const workshopImage =
    workshop_images?.length > 0
      ? new WorkshopImage(workshop_images[0].id, workshop_images[0].image)
      : null;
  const convertedWorkshop = convertWorkshop(workshop, workshopImage);

  const timePropositions = time_proposition
    ? new VisitTimeProposition(
        id,
        time_proposition?.first_proposition,
        time_proposition?.second_proposition,
      )
    : null;

  const alternativeTimePropositions = alternative_time_proposition
    ? new VisitTimeProposition(
        id,
        alternative_time_proposition?.first_proposition,
        alternative_time_proposition?.second_proposition,
      )
    : null;

  const workshopRejectedVisit =
    rejection?.length > 0
      ? new WorkshopRejectedVisit(
          rejection[0].first_proposition,
          rejection[0].second_proposition,
          rejection[0].rejection_reason,
        )
      : null;

  const contact = new VisitContact(id, car_ownership?.phone, workshop?.phone ?? null);

  const visitDetail = new Visit(
    id,
    car_ownership,
    workshop_ownership,
    scheduled_time,
    message_from_client,
    message_from_workshop,
    status,
    time_preference,
    timePropositions,
    alternativeTimePropositions,
    contact,
    convertedCar,
    convertedWorkshop,
    workshopRejectedVisit,
    issuing_invoice,
    service_scope_status,
    is_reviewed,
    initiated_by,
  );

  return (dispatch) => {
    dispatch({
      type: GET_CLIENT_VISIT_DETAIL,
      visitDetail,
    });
  };
};

export const getWorkshopVisitDetail = (data) => {
  const {
    id,
    car_ownership,
    workshop_ownership,
    scheduled_time,
    message_from_client,
    message_from_workshop,
    status,
    time_preference,
    time_proposition,
    alternative_time_proposition,
    car,
    car_images,
    workshop,
    rejection,
    issuing_invoice,
    service_scope_status,
    is_reviewed,
    initiated_by,
  } = data;

  const image = car_images.length > 0 ? new CarImage(car_images[0].id, car_images[0].image) : null;
  const convertedCar = convertCar(car, car_ownership, undefined, image);

  const { workshop_images } = workshop;
  const workshopImage =
    workshop_images?.length > 0
      ? new WorkshopImage(workshop_images[0].id, workshop_images[0].image)
      : null;
  const convertedWorkshop = convertWorkshop(workshop, workshopImage);

  const timePropositions = time_proposition
    ? new VisitTimeProposition(
        id,
        time_proposition?.first_proposition,
        time_proposition?.second_proposition,
      )
    : null;

  const alternativeTimePropositions = alternative_time_proposition
    ? new VisitTimeProposition(
        id,
        alternative_time_proposition?.first_proposition,
        alternative_time_proposition?.second_proposition,
      )
    : null;

  const workshopRejectedVisit =
    rejection?.length > 0
      ? new WorkshopRejectedVisit(
          rejection[0].first_proposition,
          rejection[0].second_proposition,
          rejection[0].rejection_reason,
        )
      : null;

  const contact = new VisitContact(id, car_ownership?.phone, workshop?.phone ?? null);

  const visitDetail = new Visit(
    id,
    car_ownership,
    workshop_ownership,
    scheduled_time,
    message_from_client,
    message_from_workshop,
    status,
    time_preference,
    timePropositions,
    alternativeTimePropositions,
    contact,
    convertedCar,
    convertedWorkshop,
    workshopRejectedVisit,
    issuing_invoice,
    service_scope_status,
    is_reviewed,
    initiated_by,
  );

  return (dispatch) => {
    dispatch({
      type: GET_WORKSHOP_VISIT_DETAIL,
      visitDetail,
    });
  };
};
